import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="age-verification"
export default class extends Controller {
  static targets = ["checkbox", "submit"]

  connect() {
    this.updateSubmitButton()
  }

  updateSubmitButton() {
    this.submitTarget.disabled = !this.checkboxTarget.checked
  }
}
